import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import PageHeader from 'components/Header/Page';
import React, { useEffect, useRef, useState } from 'react';
import DateFilterDropdown from 'components/Dropdown/DateFilter';
import LoaderComponent from 'components/Loader';
import {
	addOrUpdateInsights,
	deleteInsights,
	getInsights,
	fetchMimsMetrics,
	fetchMimsMetricTrend,
	fetchProblemTicketsMetricTrend,
	fetchProblemTecketsMetrics,
	fetchIncidentsSummary,
    fetchTechnologyDataList,
    fetchChannelMetrics,
    fetchResolutionMetrics,
    fetchIncidentTechnologyList,
} from '../../../service/service';
import moment from 'moment';
import MultiLineWidget from 'components/Widgets/MultiLineChart';
import { CustomizedDataGrid } from 'components/customized_data_grid';
import dayjs from 'dayjs';
import RowTypography from 'components/Table/RowTypography';
import IncidentFilter from 'components/Dropdown/IncidentFilter';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import PieInfoWidget from 'components/Widgets/PieInfoWidgetPrimary';
import { useTimezoneController } from 'Context/contexts/TimezoneContext';
import SegmentedBarChart from 'components/Widgets/SegmentedBarchartWidget';
import {useTheme} from "@mui/material/styles";
import CustomBarChartWidget from 'components/Widgets/CustomBarchartWidget';
import { fetchL1L2L3Metrics } from '../../../service/service';

const Overview = () => {
	const theme= useTheme();
	const colors = theme.palette;
	const [timezoneState, timezoneDispatch] = useTimezoneController();
	const timezoneFilter = timezoneState.timezone;
	const [sectorName, setSectorName] = useState('all');
	const isXOps = true;
	const getInitialMonth = () => {
		return isXOps ? moment().subtract(1, 'month').format('YYYY-MM') : '0M';
	};
	const [customMonth, setCustomMonth] = useState(getInitialMonth());
	const [filterMonth, setFilterMonth] = useState(getInitialMonth());

	const [insights, setInsights] = useState<Insights[]>([]);
	const [loader, setLoader] = useState<boolean>(false);
	const [gridLoader, setGridLoader] = useState<boolean>(false);
	const [mimsMetricChartLoader, SetMimsMetricChartLoader] = useState<boolean>(true);
	const [mimsMetricChartOptions, SetMimsMetricChartOptions] = useState<Record<string, any>>({});
    const [isClosed, setIsClosed] = useState('open');
	const [tableData, setTableData] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [totalPages, setTotalPages] = useState(0);
    const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [chartPreference, setChartPreference] = useState('all');
	const [mimsRawData, setMimsRawData] = useState<{ currentYearIncident: any[]; lastYearIncident: any[] }>({
		currentYearIncident: [],
		lastYearIncident: []
	});
	const [selectedMimsType, setSelectedMimsType] = useState<'all' | 'Actual MIMs' | 'Preventive MIMs'>('all');

	const [insightCustomMonth, setInsightCustomMonth] = useState(getInitialMonth());
	const [insightFilterMonth, setInsightFilterMonth] = useState(getInitialMonth());

	const [problemMetricChartLoader, SetProblemMetricChartLoader] = useState<boolean>(true);
	const [problemMetricChartOptions, SetProblemMetricChartOptions] = useState<Record<string, any>>({});
	const [problemTableData, setProblemTableData] = useState<Row[]>([]);
	const [problemGridLoader, setProblemGridLoader] = useState<boolean>(false);
	const [problemSortingInfo, setProblemSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [problemCustomMonth, setProblemCustomMonth] = useState(getInitialMonth());
	const [problemFilterMonth, setProblemFilterMonth] = useState(getInitialMonth());

	const [widgetData, setWidgetData] = useState<any[]>([]);
	const [chartLoading, setChartLoading] = useState(true);
	const [majorProblemBacklogData, setMajorProblemBacklogData] = useState<PieChartItem[]>([]);
    const [barChartOptions, setBarChartOptions] = useState<any>({});
    const [availabilityData, setAvailabilityData] = useState<any[]>([]);
    const [avilabilityBarChartOptions, setAvilabilityBarChartOptions] = useState<any>({});
    const [avilabilityLoader, setAvilabilityLoader] = useState<boolean>(false);
    const [expandedMetricsIndex, setExpandedMetricsIndex] = useState<number | null>(null);
    const [channelMetrics, setChannelMetrics] = useState<PieChartItem[]>([])
	const [majorProblemBacklogChange, setMajorProblemBacklogChange] = useState({
        value: 0,
        type: ''
    });
    const [channelChange, setChannelChange] = useState({
        value: 0,
        type: ''
    });
    const [resolutionMetricsChange, setResolutionMetricsChange] = useState({
        value: 0,
        type: ''
    });
    const [l1resolutionMetricsChange, setL1resolutionMetricsChange] = useState({
        value: 0,
        type: ''
    });
    const [channelMetricsLoading, setChannelMetricsLoading] = useState(false);
    const [resolutionMetricsLoading, setResolutionMetricsLoading] = useState(false);
    const [l1resolutionMetricsLoading, setL1ResolutionMetricsLoading] = useState(false);
    const [resolutionMetrics, setResolutionMetrics] = useState<PieChartItem[]>([])
    const [l1resolutionMetrics, setL1ResolutionMetrics] = useState<PieChartItem[]>([])
	const [majorProblemBacklogLoading, setMajorProblemBacklogLoading] = useState(true);
	const [enableSectorCut, setEnableSectorCut] = useState<any>({});
	const [sectorMetrics, setSectorMetrics] = useState<any>([]);

	const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

	const mimColorMapping = {
		MIMs: '#00B4C5',
		'Preventive MIMs': '#5BA300'
	};

	const p3IncidentsColorMapping = {
		Databricks: '#299BFF',
		PowerBI: '#FFC231',
		Teradata: '#00D08D',
		Tableau: '#FD783D',
		Presto: '#8884D8',
		Others: '#707070'
	};

	const majorProblemBacklogColorMapping = {
		'Root Cause Analysis': '#00B4C5',
		'Fix In Progress': '#5BA300',
		Closed: '#FFA200'
	};
	interface PieChartItem {
		name: string;
		value: number;
		formattedName: string | number;
	}
	interface Insights {
		insightId: number;
		title: string;
		description: string;
		opsType: string;
		createdBy: string;
		updatedBy: string;
		createdDate: string;
		updatedDate: string;
	}

	interface Row {
		Technology: string;
		AssignmentGroup: number;
		PlatformImpact: string;
		OutageDuration: number;
		OutageType: number;
		Incident_Id: string;
		Problem_Id: string;
		// MTTR_RCA: string;
	}

    interface IncidentPriorityData {
        YearMonth: string;
        veryLow?: number;
        low?: number;
        moderate?: number;
    }

    interface SlaData {
        YearMonth: string;
        avgSLA: number;
    }

    // This interface describes the full shape of the data from the API
    interface ApiData {
        mim?: any[];
        p3Incidents?: any[];
        majorProblemBacklog?: any[];
        incidentsByPriority?: IncidentPriorityData[];
        resolutionSLA?: SlaData[];
        responseSLA?: SlaData[];
    }

    const intakeColorMapping = { 'Self service': colors.widget.colors.color1, 'System generated': colors.widget.colors.color6, 'Human in loop': colors.widget.colors.color2 };
    const resolutionColorMapping = { 'Human in loop': colors.widget.colors.color2, 'Self healing': colors.widget.colors.color1 };
    const l1ResolutionColorMapping = { 'L1': colors.widget.colors.color1, 'L2': colors.widget.colors.color2, 'L3': colors.widget.colors.color6 };

    const incidentIntakeTooltip = [{ title: 'System Generated', description: 'Automated incidents created by ServiceNow Alerts.', }, { title: 'Self-Service', description: 'Incidents created through Chester, ServiceNow Self-Service portal & Webchat', }, { title: 'Human in the loop', description: 'Incidents created through human coordination via emails, Teams IM, Direct walk-in & Phone call.', }, ]
    const incidentResolutionTooltip = [{ title: 'Self-Healing (L0)', description: 'Incidents resolved without human intervention through BOTs & Auto correction identified by "Resolved By" & "Closed By" fields in ServiceNow.', }, { title: 'Human in the Loop (L1, L2 & L3)', description: 'Incidents Resolved by sustain personnel.', }, ]

    const getMonthLabel = (yearMonth: string) => dayjs(`${yearMonth}-01`).format("MMM YYYY");

	async function fetchChartData(selectedDate: any, isClosedDate: any, timezoneFilter: string, sector: string) {
		try {
			setChartLoading(true);
			isClosedDate = isClosedDate === 'closed' ? true : false;
			const res = await fetchIncidentsSummary(selectedDate, isClosedDate, timezoneFilter, sector);
			if (res.success) {
				const result = transformData(res.data);
				setWidgetData(result);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setChartLoading(false);
		}
	}

    async function availabilityChartData(selectedMonth: any, metricsType: string, isClosedDate: any, timezoneFilter: string, sector: string) {
        try {
            setAvilabilityLoader(true);
            isClosedDate = isClosedDate === 'closed' ? true : false;
            const res = await fetchTechnologyDataList({ selectedMonth, metricsType, isClosedDate, timezoneFilter, sector });
            if (res.success && res.data.data) {
                const formattedAvailability = res.data.data.map((item: any) => ({ name: item.platform, value: item.availability }));
                setAvailabilityData(formattedAvailability);
                const xAxisLabels = formattedAvailability.map((item: any) => item.name);
                const seriesData = formattedAvailability.map((item: any) => item.value);
                const slaValue = 99.975;
                const lowestAvailabilityValue = formattedAvailability.length > 0 ? Math.min(...formattedAvailability.map((i: {value: number}) => i.value)) : 100;
                const minYValue = lowestAvailabilityValue > 99.90 ? 99.90 : 99.5;
                const BarChartoptions = {
                    backgroundColor: 'transparent',
                    tooltip: { trigger: 'axis', formatter: (params: any) => `${params[0].name}<br/>${params[0].seriesName} :  ${params[0].value}%` },
                    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
                    xAxis: { 
                        type: 'category', 
                        data: xAxisLabels, 
                        axisTick: { show: false }, 
                        axisLine: { show: true }, 
                        axisLabel: { 
                            color: colors.widget.chart.labelColorSecondary, 
                            interval: 0, 
                            rotate: 90, 
                            formatter: function (value: any) {
                                return value.length > 10 ? value.substring(0, 10) + '…' : value;
                            }, 
                        } 
                    },
                    yAxis: { type: 'value', min: minYValue, max: 100, splitLine: { show: false }, axisLabel: { color: colors.widget.chart.labelColorSecondary, formatter: (val: number) => val.toFixed(1) } },
                    series: [{
                        label: { show: true, position: 'top', fontSize: 12, color: colors.widget.chart.labelColorSecondary },
                        name: 'Availability', type: 'bar', data: seriesData, itemStyle: { color: colors.widget.colors.color2 },
                        markLine: {
                            symbol: 'none',
                            label: { show: true, position: 'end', align: 'right', verticalAlign: 'bottom', formatter: '{c}% SLA', color: colors.widget.chart.labelColorSecondary, },
                            lineStyle: { color: colors.widget.colors.color1, width: 2, type: 'solid', },
                            data: [{ yAxis: 99.9, name: 'SLA' }],
                        },
                    }],
                };
                setAvilabilityBarChartOptions(BarChartoptions);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setAvilabilityLoader(false);
        }
    }

	// Function to transform response data into widget-friendly format
	const transformData = (response: any) => {
		const data : ApiData = response?.data || response || {};
		let widgetData: any[] = [];

		if (data.mim && data.mim?.length > 0) {
			const item = data.mim[0];
			const change =
				item.lastMonthCount === 0
					? item.currentMonthCount > 0
						? 100
						: 0
					: ((item.currentMonthCount - item.lastMonthCount) / item.lastMonthCount) * 100;
			const chartData = [
				{ name: 'MIMs', value: item.mimsCount, formattedName: `${item.mimsCount || 0}` },
				{ name: 'Preventive MIMs', value: item.preventiveCount, formattedName: `${item.preventiveCount || 0}` }
			];

			widgetData.push({
				title: 'MIMs',
				value: item.totalCount,
				data: chartData,
				change: Math.abs(Number(change.toFixed(2))),
				changeType: item.currentMonthCount > item.lastMonthCount ? 'increase' : 'decrease'
			});
		}

		if (data.p3Incidents && data.p3Incidents?.length > 0) {
			const item = data.p3Incidents[0];
			const change =
				item.lastMonthCount === 0
					? item.currentMonthCount > 0
						? 100
						: 0
					: ((item.currentMonthCount - item.lastMonthCount) / item.lastMonthCount) * 100;
			const chartData = (item.technology || []).map((tech: any) => ({
				name: tech.name,
				value: tech.count,
				formattedName: `${tech.count}`
			}));

			widgetData.push({
				title: 'P3 Incidents',
				value: item.totalCount,
				data: chartData,
				change: Math.abs(Number(change.toFixed(2))),
				changeType: item.currentMonthCount > item.lastMonthCount ? 'increase' : 'decrease'
			});
		}

		if (data.majorProblemBacklog && data.majorProblemBacklog?.length > 0) {
			const item = data.majorProblemBacklog[0];
			const total = item.rcaCount + item.fixInProgressCount + item.closedCount + item.newCount;
			const change =
				item.lastMonthCount === 0
					? item.currentMonthCount > 0
						? 100
						: 0
					: ((item.currentMonthCount - item.lastMonthCount) / item.lastMonthCount) * 100;
			const changeType = item.currentMonthCount > item.lastMonthCount ? 'increase' : 'decrease'

			const backlogData = [
				{ name: 'Root Cause Analysis', value: item.rcaCount, formattedName: `${item.rcaCount}` },
				{ name: 'Fix In Progress', value: item.fixInProgressCount, formattedName: `${item.fixInProgressCount}` },
				{ name: 'Closed', value: item.closedCount, formattedName: `${item.closedCount}` },
				{ name: 'New', value: item.newCount, formattedName: `${item.newCount}` }
			];

			setMajorProblemBacklogData(backlogData.sort((a, b) => b.name.localeCompare(a.name)));
            setMajorProblemBacklogChange({value: Math.abs(Number(change.toFixed(2))), type: changeType});
			setMajorProblemBacklogLoading(false);
		}

        if (data.incidentsByPriority || data.resolutionSLA || data.responseSLA) {
            const allMonths = new Set<string>([
                ...(data.incidentsByPriority?.map((d: any) => d.YearMonth) || []),
                ...(data.resolutionSLA?.map((d: any) => d.YearMonth) || []),
                ...(data.responseSLA?.map((d: any) => d.YearMonth) || [])
            ]);
            const sortedMonths = Array.from(allMonths).sort();
            
            const incidentsMap = new Map((data.incidentsByPriority ?? []).map((item: any) => [item.YearMonth, item]));
            const resolutionSlaMap = new Map((data.resolutionSLA ?? []).map((item: any) => [item.YearMonth, item.avgSLA]));
            const responseSlaMap = new Map((data.responseSLA ?? []).map((item: any) => [item.YearMonth, item.avgSLA]));

            const xAxisLabels = sortedMonths.map(month => getMonthLabel(month));
            const veryLowData = sortedMonths.map(month => incidentsMap.get(month)?.veryLow || 0);
            const lowData = sortedMonths.map(month => incidentsMap.get(month)?.low || 0);
            const moderateData = sortedMonths.map(month => incidentsMap.get(month)?.moderate || 0);
            const resolutionSlaData = sortedMonths.map(month => resolutionSlaMap.get(month) ?? null);
            const responseSlaData = sortedMonths.map(month => responseSlaMap.get(month) ?? null);

			const allBarValues = [...veryLowData, ...lowData, ...moderateData];
			const maxValue = Math.max(0, ...allBarValues);
			const stepSize = Math.max(100, Math.ceil(maxValue / 4 / 100) * 100);
			const maxYAxis = Math.ceil(maxValue / stepSize) * stepSize;

			const options = {
				textStyle: { color: colors.widget.chart.labelColorSecondary }, backgroundColor: colors.widget.background.chart, tooltip: { trigger: 'axis' },
				legend: { data: ['Very Low', 'Low', 'Moderate', 'Response SLA %', 'Resolution SLA %'], left: 0, bottom: 0, textStyle: { color: colors.widget.chart.legendTextColor }, type: 'scroll', pageIconColor: colors.widget.chart.legendActiveUpDownIconColor, pageIconInactiveColor: colors.widget.chart.legendInactiveUpDownIconColor, pageTextStyle: { color: colors.widget.chart.legendTextColor, fontSize: 10 }, pageButtonItemGap: 5, pageButtonGap: 10, },
				grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
				xAxis: [{ type: 'category', data: xAxisLabels, axisTick: { show: false }, axisLine: { show: true }, axisLabel: { color: colors.widget.chart.labelColorSecondary } }],
				yAxis: [
					{ type: 'value', min: 0, max: maxYAxis > 0 ? maxYAxis : 100, interval: stepSize, axisLabel: { formatter: '{value}', color: colors.widget.chart.labelColorSecondary }, splitLine: { show: false } },
					{ type: 'value', min: 0, max: 100, interval: 25, axisLabel: { formatter: '{value}%', color: colors.widget.chart.labelColorSecondary }, splitLine: { show: false } }
				],
				series: [
                    { label: { show: true, position: 'top', fontSize: 10, color: colors.widget.chart.labelColorSecondary }, name: 'Very Low', type: 'bar', data: veryLowData, itemStyle: { color: colors.widget.colors.color1 }, barGap: '10%' },
                    { label: { show: true, position: 'top', fontSize: 10, color: colors.widget.chart.labelColorSecondary }, name: 'Low', type: 'bar', data: lowData, itemStyle: { color: colors.widget.colors.color2 }, barGap: '10%' },
                    { label: { show: true, position: 'top', fontSize: 10, color: colors.widget.chart.labelColorSecondary }, name: 'Moderate', type: 'bar', data: moderateData, itemStyle: { color: colors.widget.colors.color3 }, barGap: '10%' },
                    { label: { show: true, position: 'top', fontSize: 10, color: colors.widget.chart.labelColorSecondary }, name: 'Response SLA %', type: 'line', yAxisIndex: 1, smooth: true, data: responseSlaData, itemStyle: { color: colors.widget.colors.color4 } },
                    { label: { show: true, position: 'bottom', fontSize: 10, color: colors.widget.chart.labelColorSecondary }, name: 'Resolution SLA %', type: 'line', yAxisIndex: 1, smooth: true, data: resolutionSlaData, itemStyle: { color: colors.widget.colors.color5 } }
                ]
			};
			setBarChartOptions(options);
		}
		return widgetData;
	};

    async function loadChannelMetrics(selectedDate: any, isClosedDate: any, timezoneFilter: string, sector: string) {
        try {
            setChannelMetricsLoading(true);
            isClosedDate = isClosedDate === 'closed' ? true : false;
            const res = await fetchChannelMetrics(selectedDate, isClosedDate, timezoneFilter, sector, undefined, undefined);
            if (res.success && res.data?.channelMetric?.length > 0) {
                const item = res.data?.channelMetric[0];
                const totalCount = item.selfServeCount + item.humanInLoopCount + item.systemGeneratedCount;
                const change =
				item.lastMonthCount === 0
					? item.currentMonthCount > 0
						? 100
						: 0
					: ((item.currentMonthCount - item.lastMonthCount) / item.lastMonthCount) * 100;
                const changeType = item.currentMonthCount > item.lastMonthCount ? 'increase' : 'decrease'
                setChannelChange({value: Math.abs(Number(change.toFixed(2))), type: changeType});
                if (totalCount > 0) {
                    const channelData = [
                        { name: 'Self service', value: item.selfServeCount, formattedName: item.selfServeCount },
                        { name: 'Human in loop', value: item.humanInLoopCount, formattedName: item.humanInLoopCount },
                        { name: 'System generated', value: item.systemGeneratedCount, formattedName: item.systemGeneratedCount }
                    ];
                    setChannelMetrics(channelData);
                } else {
                        setChannelMetrics([{ name: 'Self service', value: 0, formattedName: 0 }, { name: 'Human in loop', value: 0, formattedName: 0 }, { name: 'System generated', value: 0, formattedName: 0 }]);
                }
            } else {
                setChannelMetrics([{ name: 'Self service', value: 0, formattedName: 0 }, { name: 'Human in loop', value: 0, formattedName: 0 }, { name: 'System generated', value: 0, formattedName: 0 }]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setChannelMetricsLoading(false);
        }
    }
    
    async function loadResolutionMetrics(selectedDate: any, isClosedDate: any, timezoneFilter: string, sector: string) {
        try {
            setResolutionMetricsLoading(true);
            isClosedDate = isClosedDate === 'closed' ? true : false;
            const res = await fetchResolutionMetrics(selectedDate, isClosedDate, timezoneFilter, sector, undefined, undefined);
            if (res.success && res.data?.resolutionMetric?.length > 0) {
                const item = res.data?.resolutionMetric[0];
                const totalCount = item.selfHealingCount + item.humanInLoopCount;
                const change =
                    item.lastMonthCount === 0
                        ? item.currentMonthCount > 0
                            ? 100
                            : 0
                        : ((item.currentMonthCount - item.lastMonthCount) / item.lastMonthCount) * 100;
                const changeType = item.currentMonthCount > item.lastMonthCount ? 'increase' : 'decrease'
                setResolutionMetricsChange({value: Math.abs(Number(change.toFixed(2))), type: changeType});
                if (totalCount > 0) {
                    const resolutionData = [
                        { name: 'Self healing', value: item.selfHealingCount, formattedName: item.selfHealingCount },
                        { name: 'Human in loop', value: item.humanInLoopCount, formattedName: item.humanInLoopCount }
                    ];
                    setResolutionMetrics(resolutionData);
                } else {
                    setResolutionMetrics([{ name: 'Self Healing', value: 0, formattedName: 0 }, { name: 'Human in loop', value: 0, formattedName: 0 }]);
                }
            } else {
                setResolutionMetrics([{ name: 'Self Healing', value: 0, formattedName: 0 }, { name: 'Human in loop', value: 0, formattedName: 0 }]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setResolutionMetricsLoading(false);
        }
    }

    async function loadL1ResolutionMetrics(selectedDate: any, isClosedDate: any, timezoneFilter: string, sector: string) {
        try {
            setL1ResolutionMetricsLoading(true);
            isClosedDate = isClosedDate === 'closed' ? true : false;
            const res = await fetchL1L2L3Metrics(selectedDate, isClosedDate, timezoneFilter, sector);
            if (res.success && res.data?.resLevelMetric?.length > 0) {
                const item = res.data.resLevelMetric[0];
                const totalCount = item.L1Count + item.L2Count + item.L3Count;
                const change =
				item.lastMonthCount === 0
					? item.currentMonthCount > 0
						? 100
						: 0
					: ((item.currentMonthCount - item.lastMonthCount) / item.lastMonthCount) * 100;
                const changeType = item.currentMonthCount > item.lastMonthCount ? 'increase' : 'decrease'
                setL1resolutionMetricsChange({value: Math.abs(Number(change.toFixed(2))), type: changeType});
                if (totalCount > 0) {
                    const resolutionData = [
                        { name: 'L1', value: item.L1Count, formattedName: item.L1Count },
                        { name: 'L2', value: item.L2Count, formattedName: item.L2Count },
                        { name: 'L3', value: item.L3Count, formattedName: item.L3Count }
                    ];
                    setL1ResolutionMetrics(resolutionData);
                } else {
                    setL1ResolutionMetrics([{ name: 'L1', value: 0, formattedName: 0 }, { name: 'L2', value: 0, formattedName: 0 }, { name: 'L3', value: 0, formattedName: 0 }]);
                }
            } else {
                setL1ResolutionMetrics([{ name: 'L1', value: 0, formattedName: 0 }, { name: 'L2', value: 0, formattedName: 0 }, { name: 'L3', value: 0, formattedName: 0 }]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setL1ResolutionMetricsLoading(false);
        }
    }

	useEffect(() => {
		fetchChartData(filterMonth, 'open', timezoneFilter, sectorName);
        availabilityChartData(filterMonth, 'Platform', 'open', timezoneFilter, sectorName);
        loadChannelMetrics(filterMonth, 'open', timezoneFilter, sectorName);
        loadResolutionMetrics(filterMonth, 'open', timezoneFilter, sectorName);
        loadL1ResolutionMetrics(filterMonth, 'open', timezoneFilter, sectorName);
        listTableData({ pageNumber: 1, size: 100, sortingInfo, selectedDate: filterMonth, isClosedDate: 'open', timezoneFilter, sector: sectorName });
	}, []);

    const calculateTableData = (rawData: any[]) => {
            const totalRow = rawData.reduce((acc, row) => { acc.totalIncidents += row.totalIncidents; acc.criticalIncidents += row.criticalIncidents; acc.alerts += row.alerts; return acc; }, { totalIncidents: 0, criticalIncidents: 0, alerts: 0 });
            const finalData = [ ...rawData, { id: 'total-row', technology: '', totalIncidents: totalRow.totalIncidents.toLocaleString(), criticalIncidents: totalRow.criticalIncidents.toLocaleString(), alerts: totalRow.alerts.toLocaleString() } ];
            return finalData;
        };
    
        const defaultColumnNames = ['Technology', 'Total Incidents', 'Critical Incidents (P3)', 'Alerts'];
        let dynamicWidth: any;
        useEffect(() => {
            const handleResize = () => { dynamicWidth = window.innerWidth < 600 ? 300 : (window.innerWidth / 4) - 100; };
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

    async function listTableData({ pageNumber, size, sortingInfo, selectedDate, isClosedDate, timezoneFilter, sector }: any) {
            try {
                setLoader(true);
                isClosedDate = isClosedDate === 'closed' ? true : false;
                const res = await fetchIncidentTechnologyList({ page: pageNumber, size, sortBy: sortingInfo.sortBy, orderBy: sortingInfo.sortDir, dateFilter: selectedDate, isClosedDate: isClosedDate, timezoneFilter: timezoneFilter, sector: sector });
                if (res.success) {
                    const result = calculateTableData(res.data.result);
                    setTableData(result);
                    setPaginationData(res.data.page);
                    setPage(res.data.page.currentPage);
                    setPageSize(res.data.page.size);
                    setTotalPages(res.data.page.totalPages);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        }

    const getColumns = () => {
            const columnMap: Array<{ key: string; label: string }> = [ { key: 'technology', label: 'Technology' }, { key: 'totalIncidents', label: 'Total Incidents' }, { key: 'criticalIncidents', label: 'Critical Incidents (P3)' }, { key: 'alerts', label: 'Alerts' } ];
            return columnMap.map((col) => {
                if (col.key === 'technology') {
                    return { key: col.key, name: col.label, resizable: true, width: dynamicWidth, formatter: ({ row }: any) => row.id === 'total-row' ? <RowTypography sx={{ fontWeight: 'bold', width: '100%' }}>TOTAL</RowTypography> : <RowTypography sx={{ width: '100%' }}>{row.technology}</RowTypography> };
                } else {
                    return { key: col.key, name: col.label, resizable: true, width: dynamicWidth, formatter: ({ row }: any) => row.id === 'total-row' ? <RowTypography sx={{ fontWeight: 'bold', width: '100%' }}>{row[col.key]}</RowTypography> : <RowTypography sx={{ width: '100%' }}>{row[col.key]}</RowTypography>};
                }
            });
        };
    
        const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => listTableData({ pageNumber: value, size: pageSize, sortingInfo, selectedDate: filterMonth, isClosed, timezoneFilter: timezoneFilter });
        const handlepageSizeChange = (event: any) => listTableData({ pageNumber: 1, size: event.target.value, sortingInfo, selectedDate: filterMonth, isClosed, timezoneFilter: timezoneFilter });
        const handleSorting = (sortingInfo: any) => listTableData({ pageNumber: page, size: pageSize, sortingInfo, selectedDate: filterMonth, isClosed, timezoneFilter: timezoneFilter, sector: sectorName });

	const cards = [
		...widgetData.map((widget, index) => ({
			key: `wdg-${index}`,
			id: 'mims',
			isExpanded: expandedIndex === index,
			render: (
				<PieInfoWidget
					title={<HighlightedText text={widget.title} />}
					value={widget.value}
					change={widget.change}
					changeType={widget.changeType}
					isLoading={chartLoading}
					seriesData={widget.data}
					showDollar={false}
					colorMapping={widget.title === 'P3 Incidents' ? p3IncidentsColorMapping : mimColorMapping}
					tooltipLabel=""
					enableSectorCut={false}
					setEnableSectorCut={false}
					isExpanded={expandedIndex === index}
					onToggleExpand={() => setExpandedIndex((prev) => (prev === index ? null : index))}
				/>
			)
		})),
		{
			key: 'wdg-backlog',
			id: 'major-problem-backlog',
			isExpanded: expandedIndex === widgetData.length,
			render: (
				<PieInfoWidget
					title={<HighlightedText text="Major Problem Backlog" />}
					value={majorProblemBacklogData.reduce((sum, a) => sum + a.value, 0)}
					change={majorProblemBacklogChange.value}
					changeType={majorProblemBacklogChange.type}
					isLoading={chartLoading}
					seriesData={majorProblemBacklogData}
					showDollar={false}
					colorMapping={majorProblemBacklogColorMapping}
					tooltipLabel=""
					enableSectorCut={false}
					setEnableSectorCut={false}
					isExpanded={expandedIndex === widgetData.length}
					onToggleExpand={() => setExpandedIndex((prev) => (prev === widgetData.length ? null : widgetData.length))}
				/>
			)
		}
	];

    const metricsCards = [
    {
        key: "wdg-intake",
        id: "incident-intake-channel-metrics",
        isExpanded: expandedMetricsIndex === 0,
        render: (
        <PieInfoWidget
            title={<HighlightedText text="Incident Intake Channel Metrics" />}
            value={channelMetrics.reduce((sum, a) => sum + a.value, 0)}
            tooltipLabel={incidentIntakeTooltip}
            change={channelChange.value}
            changeType={channelChange.type}
            isLoading={channelMetricsLoading}
            seriesData={channelMetrics}
            showDollar={false}
            colorMapping={intakeColorMapping}
            isExpanded={expandedMetricsIndex === 0}
            onToggleExpand={() =>
            setExpandedMetricsIndex((prev) => (prev === 0 ? null : 0))
            }
        />
        ),
    },
    {
        key: "wdg-resolution",
        id: "incident-resolution-metrics",
        isExpanded: expandedMetricsIndex === 1,
        render: (
        <PieInfoWidget
            title={<HighlightedText text="Incident Resolution Metrics" />}
            value={resolutionMetrics.reduce((sum, a) => sum + a.value, 0)}
            tooltipLabel={incidentResolutionTooltip}
            change={resolutionMetricsChange.value}
            changeType={resolutionMetricsChange.type}
            isLoading={resolutionMetricsLoading}
            seriesData={resolutionMetrics}
            showDollar={false}
            colorMapping={resolutionColorMapping}
            isExpanded={expandedMetricsIndex === 1}
            onToggleExpand={() =>
            setExpandedMetricsIndex((prev) => (prev === 1 ? null : 1))
            }
        />
        ),
    },
    {
        key: "wdg-l1-l2-l3-resolution-metrics",
        id: "l1-l2-l3-resolution-metrics",
        isExpanded: expandedMetricsIndex === 2,
        render: (
        <PieInfoWidget
            title={<HighlightedText text="L1/L2/L3 Resolution Metrics" />}
            value={l1resolutionMetrics.reduce((sum, a) => sum + a.value, 0)}
            tooltipLabel=""
            change={l1resolutionMetricsChange.value}
            changeType={l1resolutionMetricsChange.type}
            isLoading={l1resolutionMetricsLoading}
            seriesData={l1resolutionMetrics}
            showDollar={false}
            colorMapping={l1ResolutionColorMapping}
            isExpanded={expandedMetricsIndex === 2}
            onToggleExpand={() =>
            setExpandedMetricsIndex((prev) => (prev === 2 ? null : 2))
            }
        />
        ),
    },
    ];


	return (
		<PageWrapper>
			<Stack spacing={2}>
				{/* --- Section 1 --- */}
				<Box>
					{(() => {
						const anyExpanded = expandedIndex !== null && expandedIndex !== undefined;

						if (!anyExpanded) {
							return (
								<Grid container spacing={2}>
									{cards.map((card) => (
										<Grid item xs={12} md={6} lg={4} key={card.key} id={card.id}>
											{card.render}
										</Grid>
									))}
								</Grid>
							);
						}

						const expandedCard = cards[expandedIndex!];
						const rightCards = cards.filter((_, i) => i !== expandedIndex);

						return (
							<Grid container spacing={2}>
								<Grid item xs={12} lg={8} key={expandedCard.key} id={expandedCard.id}>
									{expandedCard.render}
								</Grid>
								<Grid item xs={12} lg={4}>
									<Grid container direction="column" spacing={2}>
										{rightCards.map((card) => (
											<Grid item xs={12} key={card.key} id={card.id}>
												{card.render}
											</Grid>
										))}
									</Grid>
								</Grid>
							</Grid>
						);
					})()}
				</Box>

				{/* --- Section 2 --- */}
				<Box>
					<Grid container spacing={2}>

						<Grid item xs={12} md={12} lg={6}>
							<CustomBarChartWidget
								title={<HighlightedText text="Platform Availability" />}
								isLoading={avilabilityLoader}
								data={availabilityData}
							/>
						</Grid>
					</Grid>
				</Box>

				{/* --- Section 3 : Intake + Resolution --- */}
				<Box>
					{(() => {
						const anyExpanded = expandedMetricsIndex !== null && expandedMetricsIndex !== undefined;

						if (!anyExpanded) {
							return (
								<Grid container spacing={2}>
									{metricsCards.map((card) => (
										<Grid item xs={12} md={6} lg={4} key={card.key} id={card.id}>
											{card.render}
										</Grid>
									))}
								</Grid>
							);
						}

						const expandedCard = metricsCards[expandedMetricsIndex!];
						const rightCards = metricsCards.filter((_, i) => i !== expandedMetricsIndex);

						return (
							<Grid container spacing={2}>
								<Grid item xs={12} lg={8} key={expandedCard.key} id={expandedCard.id}>
									{expandedCard.render}
								</Grid>
								<Grid item xs={12} lg={4}>
									<Grid container direction="column" spacing={2}>
										{rightCards.map((card) => (
											<Grid item xs={12} key={card.key} id={card.id}>
												{card.render}
											</Grid>
										))}
									</Grid>
								</Grid>
							</Grid>
						);
					})()}
				</Box>
                {loader ? ( <LoaderComponent pt={10} /> ) : (
				<Grid item xs={12} md={12} lg={12}>
					<CustomizedDataGrid
						title={<HighlightedText text="Top 10 Technologies" />}
						tableColumns={getColumns()}
						tableData={tableData}
						tableType="Summary"
						defaultColumnNames={defaultColumnNames}
						onSorting={handleSorting}
						currSorting={sortingInfo}
						page={page}
						pageSize={pageSize}
						paginationData={paginationData}
						listLength={tableData.length}
						handlepageSizeChange={handlepageSizeChange}
						handlePageChange={handlePageChange}
						isDateRangeFilter={false}
						isDisabled={false}
					/>
				</Grid>
                )}
			</Stack>
		</PageWrapper>
	);
};
export default Overview;
